import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { LevelCrudService } from 'src/app/shared/services/level-crud.service';
import { Level } from 'src/app/shared/interfaces/level';

@Component({
  selector: 'app-level-list',
  templateUrl: './level-list.component.html',
  styleUrls: ['./level-list.component.scss']
})
export class LevelListComponent implements OnInit {

  levels: Level[];
  level: Level;
  selectedLevels: Level[] = [];

  levelDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private levelService : LevelCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Levels'}
    ];

    this.levels = [];
    this.level = { } as Level ;
    //this.getAllRecords();
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.levelService.GetLevelsList(); 
    s.snapshotChanges().subscribe(data => {
      this.levels = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.levels.push(jsonItem as Level);
        }
      })
    })


   // this.getAllRecords();

    // column management
    this.cols = [
      { field: 'title', header: 'Title' },
      { field: 'description', header: 'Description' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.levelService.GetLevelsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.levels);
            doc.save('levels.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.levels);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "levels");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    this.exportService.exportToCsv(this.levels, 'levels', ['companyId', 'companyName', '$key', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.level = {} as Level;
    this.submitted = false;
    this.levelDialog = true;
  }

  deleteSelectedLevels() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected levels?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            // this.levels = this.levels.filter(val => !this.selectedLevels.includes(val));
            // this.selectedLevels = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Levelss Deleted', life: 3000});
        }
    });
  }

  editLevel(level: Level) {
    this.level = {...level};
    this.levelDialog = true;
  }

  deleteLevel(level: Level) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + level.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.levels = this.levels.filter(val => val.$key !== level.$key);
            this.level = {} as Level;
            this.levelService.DeleteLevel(level.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Level Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.levelDialog = false;
    this.submitted = false;
  }

  saveLevel() {
    this.submitted = true;

    // if (this.level.companyName.trim()) {
    //     if (this.level.$key) {
    //         this.levels[this.findIndexById(this.level.$key)] = this.level;                
    //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Level Updated', life: 3000});
    //     }
    //     else {
    //         // this.level.id = this.createId();
    //         // this.level.image = 'product-placeholder.svg';
    //         this.levels.push(this.level);
    //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Level Created', life: 3000});
    //     }
    //}

    this.levelService.AddLevel(this.level);
    this.messageService.add({severity:'success', summary: 'Successful', detail: 'Level Created', life: 3000});

        this.levels = [...this.levels];
        this.levelDialog = false;
        this.level = { } as Level;
    
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.levels.length; i++) {
        if (this.levels[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  // createId(): string {
  //   let id = '';
  //   var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   for ( var i = 0; i < 5; i++ ) {
  //       id += chars.charAt(Math.floor(Math.random() * chars.length));
  //   }
  //   return id;
  // }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeLevel(level : Level) {
    console.log("SAVE", level);
  }

}
